import { ThemeColorsKeys } from '../../styles/tokens/colors';

interface Config {
  tickColour: ThemeColorsKeys;
}

export default {
  tickColour: 'brandTwo100',
} as Config;
